import { gql } from '@apollo/client';

//{  "input": {    "resourceId",    "resourceLocalizationId"  }}"
export const DELETE_LOCALIZATION_MUTATION = gql`
    mutation deleteResourceLocalization($input: DeleteResourceLocalizationInput!) {
        result: deleteResourceLocalization(input: $input) {
            affectedRows
        }
    }
`;
